import React from "react"
import { Warning, ArrowsClockwise } from "@phosphor-icons/react"
import { cn } from "../../../lib/utils"
import { AgentAvatar } from "../AgentAvatar"
import { useAuthStore } from "../../../stores"

interface ErrorStateProps {
  collapsed?: boolean
}

export function ErrorState({ collapsed }: ErrorStateProps) {
  const { user } = useAuthStore()

  const initials = user
    ? `${user.given_name?.[0] || ""}${user.family_name?.[0] || ""}`.toUpperCase()
    : "NA"

  const handleRefresh = () => {
    window.location.reload()
  }

  if (collapsed) {
    return (
      <div className="py-3 bg-[#0d1f2d]">
        <div className="flex flex-col items-center">
          <Warning className="h-5 w-5 text-danger" />
        </div>
      </div>
    )
  }

  return (
    <div className="px-4 py-5 bg-[#0d1f2d]">
      <div className="flex flex-col items-center">
        {/* Error icon */}
        <div className="mb-3 p-3 rounded-full bg-danger/20">
          <Warning className="h-6 w-6 text-danger" />
        </div>

        {/* Error message */}
        <p className="text-[13px] font-semibold text-white text-center">
          Phone System Error
        </p>
        <p className="mt-1 text-[11px] text-white/60 text-center">
          Unable to connect to the phone system. Please refresh the page.
        </p>

        {/* Refresh button */}
        <button
          onClick={handleRefresh}
          className={cn(
            "mt-4 flex items-center justify-center gap-2 rounded-full px-5 py-2.5",
            "text-[11px] font-bold uppercase tracking-wide",
            "bg-white/10 hover:bg-white/20 text-white",
            "transition-all duration-200"
          )}
        >
          <ArrowsClockwise className="h-3.5 w-3.5" />
          <span>Refresh Page</span>
        </button>
      </div>
    </div>
  )
}
